import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  buildingDetailsContainer: {
    columnGap: '16px',
    rowGap: '16px',
    '&.focused': {
      backgroundColor: theme.evPalette.ocean[700],
      '& p': { color: `${theme.evPalette.salt[100]} !important` },
      borderRadius: '4px',
      border: 'none',
    },
  },
  addressDetailsContainer: {
    display: 'flex',
    flex: 1,
    gap: '8px',
    '@media(max-width: 640px)': {
      flexDirection: 'column',
    },
  },
  editOutlineButton: {
    alignSelf: 'start',
    textAlign: 'center',
    boxSizing: 'border-box',
    width: '48px',
    height: '32px',
    border: `1px solid ${theme.evPalette.ocean[500]}`,
    borderRadius: '4px',
    backgroundColor: theme.evPalette.salt[100],
  },
  editAddressInputContainer: {
    display: 'flex', flexDirection: 'column', flex: '1', gap: '16px',
  },
  editBuildingLabel: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '18px',
    textTransform: 'uppercase',
    color: theme.evPalette.charcoal[800],
    marginBottom: '8px',
    '& >.myev-MuiFormLabel-asterisk': {
      color: theme.evPalette.rose[900],
    },
    '&.postalcode': {
      whiteSpace: 'nowrap',
    },
    '&.error': {
      color: theme.evPalette.rose[900],
    },
  },
  inputHelperText: {
    color: `${theme.evPalette.rose[900]} !important`,
  },
  inputTextField: {
    height: '44px',
    '&.select': {
      paddingTop: 0,
      paddingBottom: 0,
      display: 'flex',
      alignItems: 'center',
    },
    '&.Mui-error > fieldset': { borderColor: `${theme.evPalette.rose[900]} !important` },
  },
  editAddressRow1: {
    width: '100%',
    columnGap: '16px',
    '@media(max-width: 640px)': {
      flexDirection: 'column',
    },
  },
  editAddressRow2: {
    width: '100%',
    columnGap: '16px',
  },
  editPropertyInfoHeading: {
    color: theme.evPalette.ocean[700],
    fontWeight: 600,
    fontSize: '18px',
  },
  editComponentButtonRow: {
    display: 'flex',
    rowGap: '16px',
    columnGap: '16px',
    height: 'max-content',
    '&>button': {
      textTransform: 'none',
      fontSize: '16px',
      padding: '10px 16px',
      height: '44px',
    },
    '@media(max-width: 1024px)': {
      width: '100%',
      flexDirection: 'column',
    },
  },
  reportAddressText: {
    color: theme.evPalette.charcoal[800],
    fontSize: '16px',
  },
}));
